const dataProjects = [
    {
    id: 1,
    price: 149000,
    name: 'One bedroom villa',
    category: 'without rice fields view'
    },
    {
    id: 2,
    price: 169000,
    name: 'One bedroom villa with rice fields view',
    category: 'with rice fields view'
    },
    {
    id: 3,
    price: 149000,
    name: 'Two bedroom villa',
    category: 'without rice fields view'
    },
    {
    id: 4,
    price: 169000,
    name: 'Two bedroom villa with rice fields view',
    category: 'with rice fields view'
    }
]
export default dataProjects;